/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, AuditReportsGetOlafReprocessJobStatusByReprocessKeyPathParams, AuditReportsGetOlafReprocessJobStatusByReprocessKey401, AuditReportsGetOlafReprocessJobStatusByReprocessKey403, AuditReportsGetOlafReprocessJobStatusByReprocessKey404 } from "../models/AuditReportsGetOlafReprocessJobStatusByReprocessKey";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetOlafReprocessJobStatusByReprocessKey } from "../axios/auditReportsGetOlafReprocessJobStatusByReprocessKey";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetOlafReprocessJobStatusByReprocessKeyQueryKey = (reprocessKey: AuditReportsGetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"]) => ["api-v2", { url: '/audit-reports/v1/olaf/reprocess/job-status-by-reprocess-key/:reprocessKey', params: {reprocessKey:reprocessKey} }] as const

export type AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryKey = ReturnType<typeof auditReportsGetOlafReprocessJobStatusByReprocessKeyQueryKey>

export function auditReportsGetOlafReprocessJobStatusByReprocessKeyQueryOptions(reprocessKey: AuditReportsGetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetOlafReprocessJobStatusByReprocessKeyQueryKey(reprocessKey)
        return queryOptions<AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByReprocessKey401 | AuditReportsGetOlafReprocessJobStatusByReprocessKey403 | AuditReportsGetOlafReprocessJobStatusByReprocessKey404>, AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, typeof queryKey>({
         enabled: !!(reprocessKey),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetOlafReprocessJobStatusByReprocessKey(reprocessKey, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Finds and returns the most recent reprocess job for the given reprocess key within the user's client.
 * @summary Get OLAF reprocess job status by reprocess key
 * {@link /audit-reports/v1/olaf/reprocess/job-status-by-reprocess-key/:reprocessKey}
 */
export function useAuditReportsGetOlafReprocessJobStatusByReprocessKey<TData = AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, TQueryData = AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, TQueryKey extends QueryKey = AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryKey>(reprocessKey: AuditReportsGetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByReprocessKey401 | AuditReportsGetOlafReprocessJobStatusByReprocessKey403 | AuditReportsGetOlafReprocessJobStatusByReprocessKey404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetOlafReprocessJobStatusByReprocessKeyQueryKey(reprocessKey)
         

         const query = useQuery({
          ...auditReportsGetOlafReprocessJobStatusByReprocessKeyQueryOptions(reprocessKey, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByReprocessKey401 | AuditReportsGetOlafReprocessJobStatusByReprocessKey403 | AuditReportsGetOlafReprocessJobStatusByReprocessKey404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}